/**
 * @fileoverview Document Viewer Modal
 *
 * Shared modal component for previewing documents (PDFs, images) inline.
 * Used by PlansDocuments, ChangeOrders, and any component that needs
 * to display file attachments in a modal instead of opening a new tab.
 *
 * @version 1.0.0
 */

import React from "react";
import { FaDownload, FaTimes } from "react-icons/fa";
import "./DocumentViewerModal.css";

/**
 * @param {Object} props
 * @param {Object} props.doc - Document object with { name/filename, url, type?, thumbnail? }
 * @param {Function} props.onClose - Handler to close the modal
 */
const DocumentViewerModal = ({ doc, onClose }) => {
  if (!doc) return null;

  const name = doc.name || doc.filename || "Document";
  const url = doc.url;
  const isPDF = doc.type === "pdf" || name.toLowerCase().endsWith(".pdf");

  return (
    <div className="doc-viewer-overlay" onClick={onClose}>
      <div className="doc-viewer-content" onClick={(e) => e.stopPropagation()}>
        <div className="doc-viewer-header">
          <h3>{name}</h3>
          <div className="doc-viewer-actions">
            <a
              href={url}
              download
              className="doc-viewer-download"
              onClick={(e) => e.stopPropagation()}
            >
              <FaDownload /> Download
            </a>
            <button
              className="doc-viewer-close"
              onClick={onClose}
              aria-label="Close"
            >
              <FaTimes />
            </button>
          </div>
        </div>
        <div className="doc-viewer-body">
          {isPDF ? (
            <iframe src={url} title={name} className="doc-viewer-pdf" />
          ) : (
            <img src={doc.thumbnail || url} alt={name} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentViewerModal;
